var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UserProfileCard',{attrs:{"user":_vm.user},on:{"delete-user":_vm.handleDeleteUser}})}
var staticRenderFns = []

export { render, staticRenderFns }